export default "__VITE_ASSET__CDhNRlto__"